'use client';

var DEFAULT_IMAGE = 'https://images.vietnamworks.com/img/company-default-logo.svg';
var SERVICE_CODE_URGENT_JOB = 'UJ';
var SERVICE_CODE_TOP_MANAGEMENT_JOB = 'TMJ';
var SERVICE_CODE_HEADHUNT_JOB = 'JPHH';
var SERVICE_CODE_HEADHUNT_JOB_MOBILE = 'JPHM';
var SUCCESS_CODE = 200;
var REQUIRED_COVER_LETTER = 1;
var badgeSettings = {
    premium: {
        name: 'Premium'
    },
    urgent: {
        name: 'Urgent'
    },
    topManagement: {
        name: 'Top management',
        utm: '?utm_source_navi=vnw_searchresults&utm_medium_navi=TopManagementJobs'
    },
    headHunter: {
        name: 'Head hunter'
    },
    new: {
        name: 'New'
    },
    matching: {
        name: 'Matching'
    }
};

export { DEFAULT_IMAGE, REQUIRED_COVER_LETTER, SERVICE_CODE_HEADHUNT_JOB, SERVICE_CODE_HEADHUNT_JOB_MOBILE, SERVICE_CODE_TOP_MANAGEMENT_JOB, SERVICE_CODE_URGENT_JOB, SUCCESS_CODE, badgeSettings };
//# sourceMappingURL=constant.js.map
